<template>
  <div class="today-alarm" >
    <div class="toptitle dn-title-bg">检查结果</div>
        <div class="topcontent dn-content-bg" v-loading="ifLoad">
            <el-row class="el-box">
                <el-col :span="16">
                    <!-- <div style="height: 160px;">
                        <div style="display:flex;justify-content:center;">
                        <div>
                            <span
                            style="background:red;height:12px;width:12px;display: inline-block;margin-right: 5px"
                            ></span>
                            <span>0-59不合格</span>
                        </div>
                        <div style="margin-left:15%">
                            <span
                            style="background:#206ee3;height:12px;width:12px;display: inline-block;margin-right: 5px"
                            ></span>
                            <span>60-100合格</span>
                        </div>
                        </div>
                        <div  class="guanBox">
                            <Guan :pieData="pieData"></Guan>
                        </div>
                    </div> -->
                    <!-- <div class="hglfont" :class="ifQualified=='合格'?'blue':'red'">{{ifQualified}}</div> -->
                </el-col>
                <!-- <el-col :span="8">
                    <div class="Toprightcontent">
                        <div
                        style="width: 80%;margin-left: 14%;"
                        >某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某某</div>
                    </div>
                    <div class="ts">温馨建议</div>
                </el-col> -->
                <div class="hglfont1" :class="ifQualified=='合格'?'blue':'red'">{{ifQualified}}</div>
            </el-row>
        </div>
    </div>
</template>
<script>
let vm;
export default {
    props:{
        checkResult:
        {
            type: Array ,
            default: () => []
        },
        ifLoad:{
            type:Boolean,
            default:false,
        },
        ifQualified:{
            type:String,
            default:'合格',
        }
    },
    data() {
        return {
            pieData:[]
        };
    },
    created() {
    },
    methods: {
    },
    watch: {
        checkResult:{
            handler(newVal,oldVal){
                let vm=this
                vm.pieData=newVal
            },
            deep:true
        }
    },
};
</script>
<style lang="scss" scoped>
.toptitle {
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.topcontent {
  height: 200px;
  padding: 5px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.el-box{
    height: 100%;
}
.Toprightcontent {
  background: #f0f3f4;
  border-radius: 4px;
  width: 100%;
  white-space: normal;
  line-height: 24px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  // font-weight: bold;
  position: relative;
  height: 195px;

  margin: 2px 0px 0px -9px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  overflow: hidden;
  text-overflow: ellipsis;
  // white-space: nowrap;
}
.ts {
  position: absolute;
  top: 5%;
  left: 61%;
  width: 2vw;
  height: 8.5vh;
  line-height: 3.5vh;
  font-size: 1rem;
  text-align: center;
  background: #05cfb5;
  writing-mode: vertical-lr;
  color: azure;
  border-radius: 10px;
}
.hglfont {
  // width: 53px;
  // height: 26px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  display: flex;
  justify-content: center;
}
.hglfont1 {
    font-size: 50px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.blue{
    color: #47D5A9;
}
.red{
    color: #FE7B80;
}
.guanBox {
  width: 100%;
  height: 100%;
}
</style>